type QuemVe = { isSeller?: boolean; organization?: { id?: string } | null } | null | undefined

// why: a URL de Contratos traz a outra parte do contrato (fetch-organization-workspaces):
// para a corretora é a empresa cliente; para o RH é a corretora. As atividades da tela
// (Documentos, Carteirinhas, Endereçabilidade, Carregar Beneficiários, Carga operadora)
// pedem dados da empresa, então o RH usa a empresa da sessão.
export function empresaDaTela(user: QuemVe, organizationIdDaUrl: string): string {
  if (user?.isSeller) return organizationIdDaUrl
  return user?.organization?.id ?? organizationIdDaUrl
}
